export const COMPOSE_PANEL_NAME = 'compose';
